import { ApiClientProps } from "hooks/useApi";
interface CRMUpdateProps {
  crmData: any;
   partnerId: string;
   locationId: string;
  apiClient: ApiClientProps;
  posType: string | null | undefined;
  isCRMEnabled: boolean;
}
const updateCRM = async ({ 
  crmData,
  partnerId,
  locationId,
  apiClient,
  posType,
  isCRMEnabled
}: CRMUpdateProps): Promise<any> => {
  if (!crmData || !partnerId || !locationId || !posType || isCRMEnabled === undefined) {
    throw new Error("Missing required parameters to update CRM.");
  }

  const formattedCrmData = crmData.map((item: { name: string; crmLocationId: string; enabled: boolean }) => ({
    "crmName": item.name.toLowerCase(),
    "crmLocationId": item.crmLocationId,
    "enabled": item.enabled,
  }));

  const response = await apiClient.put({
    path: `/middleware-admin/partners/${partnerId}/locations/${locationId}/crms`,
    headers: {
      "Content-Type": "application/json",
      posType,
    },
    body: JSON.stringify([ ...formattedCrmData ]),
    noRetry: true,
  });

  const flagData = [
    {
      "name": "crm.enabled",
      "enabled": isCRMEnabled
    }
  ];

  await apiClient.put({
    path: `/middleware-admin/partners/${partnerId}/locations/${locationId}/flags`,
    headers: {
      "Content-Type": "application/json",
      posType,
    },
    body: JSON.stringify([ ...flagData ]),
    noRetry: true,
  });

  return response.data;
};
export default updateCRM;










